import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import { formSections } from '@/forms/state/state';
import withDraft from '@/utils/draftHelper';
import { responseError } from '@/utils/errors';
import { taskSectionNames } from '../constants';

export const taskPanels = (openPanels = [0]) => ({
  panels: {
    single: openPanels,
    left: openPanels,
    middle: openPanels,
    right: openPanels,
  },
});

export const taskSections = (names = taskSectionNames) => ({
  sections: names.reduce((acc, name) => ({
    ...acc,
    [name]: { label: '', fields: [] },
  }), {}),
});

export const findTaskTemplates = ({ tasks: { templates } }, { category }) => templates[category];

export const findTaskTemplate = ({ tasks: { templates } }, { category, code }) => (
  findResult(templates, category, code)
);

const initialState = { templates: { open: { results: [] } } };

export const openTaskTemplate = ({ code }) => ({
  code,
  ...taskSections(),
  readStatus: states.PENDING,
  readErrors: [],
  ...taskPanels(),
  copy: {},
  asViewer: { on: false, uuid: null },
});

export const blankTaskTemplate = () => ({ ...readStates, ...formSections(['task']) });

export const fetchTaskTemplateState = withDraft((draft, action) => {
  draft.tasks.templates[action.category].results = [openTaskTemplate(action)];
});

export const showTaskTemplateState = (draft, { category, result }) => {
  draft.tasks.templates[category].results = [{ ...result, readStatus: states.SUCCESS, readErrors: [] }];
};

export const showTaskTemplateErrorState = withDraft((draft, action) => {
  const { activeTask } = draft.tasks;

  if (activeTask.open && activeTask.code === action.taskCode) {
    const item = findTaskTemplate(draft, action);
    item.readStatus = states.ERROR;
    item.readErrors = [responseError(action)];
  }
});

export default initialState;
